import axios from 'axios'
import { baseUrl } from '@/common/base'

const service = axios.create({
    baseURL: baseUrl,
    timeout: 20000
})

export default service

